import React, { useState, useEffect } from 'react'
import './styles.scss'
import image from './../../images/main-banner.png'
import Header from './../header/Header';
import StepsBar from './../steps-bar/StepsBar';
import { useNavigate, useLocation } from "react-router";

const MainBanner = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let [ stepTemplate, setStepTemplate ] = useState(false);

    useEffect(() => {
        if(location.pathname == "/" || location.pathname == "/shop") {
            setStepTemplate(false);
        }else{
            setStepTemplate(true);
        }
    }, [location.pathname])

    return (
        <header className={`main-banner ${stepTemplate ? 'steps-wrapper' : ''}`}>
            <img src={ image } className="banner" alt="Grenke calculator"/>
            {/* <div className="box">
                <h1>Kalkulator GRENKE</h1>
            </div> */}
            <Header />
            <StepsBar />
        </header>
    )
}

export default MainBanner;